module.exports = __webpack_public_path__ + "front/img/bg-success.5907f82b.png";